module.exports = __webpack_public_path__ + "img/logo-icon.31980cb6.png";